import angular from 'angular';
import FunnelCtrl from './funnel-controller';
import FunnelService from './funnel-service';

export default angular.module('mapmycustomersApp.deals', [])
  .controller('FunnelCtrl', FunnelCtrl)
  .factory('FunnelService', FunnelService)
  .name;
